module.exports = __webpack_public_path__ + "static/media/ceremony@2x.2737048b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/ceremony@2x.png
 ** module id = 2212
 ** module chunks = 50
 **/